import { isObservableArray } from 'mobx';

/** MobX 4 observable arrays are not native arrays. */
export const isDataList = value => Array.isArray(value) || isObservableArray(value);

/** Normalize optional CMS values before rendering. */
export const getImageUrl = value => (typeof value === 'string' ? value.trim() : '');
export const getMediaUrl = value => (isDataList(value) && value.length > 0 ? getImageUrl(value[0]?.url) : '');
export const getRecordList = value => (isDataList(value) ? value.filter(item => item && typeof item === 'object' && !isDataList(item)) : []);
